import { render, staticRenderFns } from "./orderInvoiceList.vue?vue&type=template&id=21a4cca2&"
import script from "./orderInvoiceList.vue?vue&type=script&lang=js&"
export * from "./orderInvoiceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports